import {
    SET_NOTIFICATIONS_DATA,
    SET_UNREAD_NOTIFICATION_COUNT
  } from '../../actions/types/types';
  
  const initState = {
    unreadNotificationCount: 0,
    notifications: []
  };
  
  const NotificationReducer = (state = initState, action) => {
    switch (action.type) {
      case SET_NOTIFICATIONS_DATA:
        return {
          ...state,
          notifications: action.payload.data,
        };
      case SET_UNREAD_NOTIFICATION_COUNT:
        return {
          ...state,
          unreadNotificationCount: action.payload.data,
        };
      default:
        return { ...state };
    }
  };
  
  export default NotificationReducer;
  